export const getData = ({ longitude, latitude }) =>
  fetch(`/api/postcode?longitude=${longitude}&latitude=${latitude}`).then(
    res => {
      return res.text().then(text => (text ? JSON.parse(text) : {}));
    },
  );

const getPostcode = async location => {
  const {
    coords: { latitude, longitude },
  } = location;

  const { value } = await getData({ longitude, latitude });
  return value;
};

export default getPostcode;
